import React from 'react';
import PropTypes from 'prop-types';

import EventButton from '../../../atoms/EventButton/EventButton';

const Indicator = ({ index, currentIndex, changeCurrentIndex, event }) => (
  <EventButton
    event={{
      ...event,
      value: index,
    }}
    className="ic-carousel-indicator"
    style={{ padding: 0, background: 'none' }}
    onClick={() => changeCurrentIndex(index)}
    size="large"
    icon={index === currentIndex ? 'circle' : 'circle outline'}
  />
);

Indicator.propTypes = {
  event: PropTypes.shape({}),
  index: PropTypes.string.isRequired,
  currentIndex: PropTypes.number.isRequired,
  changeCurrentIndex: PropTypes.func.isRequired,
};

Indicator.defaultProps = {
  event: {
    category: 'Carousel',
    action: 'Click',
    label: 'Image Collection',
  },
};

export default Indicator;
